import { apiClient, API_CONFIG } from '../../../core';
import type { ApiResponse } from '../../../shared';
import type {
  LC_GetAttendanceMarksIn,
  LC_GetAttendanceMarksOut,
  LC_ExportAttendanceMarksIn,
  LC_ToggleMarkEnabledOut,
  AttendanceMarksExportHybridResult,
  AttendanceMarksPage,
} from '../types';
import { mapAttendanceMarksPage } from '../mappers';


export class AttendanceMarksService {
  async getMarks(
    params: LC_GetAttendanceMarksIn,
    signal?: AbortSignal,
  ): Promise<ApiResponse<AttendanceMarksPage>> {
    const response = await apiClient.post<LC_GetAttendanceMarksOut>(
      API_CONFIG.ENDPOINTS.ATTENDANCE.MARKS_SEARCH,
      params,
      { signal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapAttendanceMarksPage(response.data) };
  }

  async exportFile(
    params: LC_ExportAttendanceMarksIn,
  ): Promise<ApiResponse<AttendanceMarksExportHybridResult>> {
    return apiClient.downloadBlobOrAcceptJob(
      API_CONFIG.ENDPOINTS.ATTENDANCE.MARKS_EXPORT,
      { method: 'POST', body: JSON.stringify(params) },
    );
  }

  async toggleMarkEnabled(
    markId: number,
    enabled: boolean,
  ): Promise<ApiResponse<LC_ToggleMarkEnabledOut>> {
    const endpoint = API_CONFIG.ENDPOINTS.ATTENDANCE.TOGGLE_MARK_ENABLED(markId);
    return apiClient.patch<LC_ToggleMarkEnabledOut>(endpoint, { enabled });
  }
}

export const attendanceMarksService = new AttendanceMarksService();
